export default "__VITE_ASSET__4a564c81__"